import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Tooltip } from 'primeng/tooltip';
import {
  ExpirationStatus,
  getDaysToExpiration,
  getExpirationStatus
} from './document-expiration.util';

@Component({
  selector: 'app-document-expiration-warning',
  templateUrl: './document-expiration-warning.component.html',
  styleUrls: ['./document-expiration-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Tooltip, TranslatePipe]
})
export class DocumentExpirationWarningComponent {
  expirationDate = input<string | null | undefined>();

  expirationStatus = computed(() => getExpirationStatus(this.expirationDate()));

  iconClass = computed(() => {
    const expirationStatus = this.expirationStatus();
    return expirationStatus === ExpirationStatus.One_Day ||
      expirationStatus === ExpirationStatus.Two_Day
      ? 'fa-alarm-exclamation'
      : 'fa-calendar-circle-exclamation';
  });

  expirationTooltipKey = computed(() => {
    switch (this.expirationStatus()) {
      case ExpirationStatus.One_Day:
        return 'documentExpiringWarning.today';
      case ExpirationStatus.Two_Day:
        return 'documentExpiringWarning.tomorrow';
      case ExpirationStatus.Week:
      case ExpirationStatus.Two_Week:
        return 'documentExpiringWarning.inDays';
      default:
        return null;
    }
  });

  daysToExpiration = computed(() => ({ days: getDaysToExpiration(this.expirationDate()) }));
}
